import { render, staticRenderFns } from "./InformationSystems.vue?vue&type=template&id=11c8c8a0&"
import script from "./InformationSystems.vue?vue&type=script&lang=js&"
export * from "./InformationSystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports